import { getOrgConfig } from '@api/organization';
import { getOrganizationIdFromStorage } from '@components/containers/procurementOrders/formComponents';
import { useQuery } from '@tanstack/react-query';

/**
 * Whether this brand measures by volume — the one switch every CBM surface hangs off.
 *
 * Reads the organisation's measurement basis. VOLUME and BOTH brands get the CBM column on
 * order lines, the volume card, the order and shipment totals, the container estimate and
 * the cap warning. A WEIGHT brand — the default, and every brand but one today — sees
 * exactly the screens it has now; nothing renders half-empty. Same query key the
 * purchase-order form already uses for its terms, so the two share one fetch.
 */
export function useCbmEnabled(): boolean {
    const organizationId = getOrganizationIdFromStorage();
    const { data } = useQuery(
        ['org-config', organizationId],
        () => getOrgConfig(organizationId as string),
        { enabled: !!organizationId, staleTime: 5 * 60_000 },
    );
    const basis = data?.measurementBasis;
    return basis === 'VOLUME' || basis === 'BOTH';
}
